import { assetsRequire } from '@client/helper';
import { i18n } from '@client/helper/i18n';
const { t } = i18n;

export const DEFAULT_FEELTYPE_IMG = assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/none.png');

// 训练感受
export function getFeelTypeOptions() {
  return [
    {
      type: 1,
      nameText: t('R9017'),
      imgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/1.png'),
      activeImgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/1-active.png')
    },
    {
      type: 2,
      nameText: t('R9018'),
      imgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/2.png'),
      activeImgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/2-active.png')
    },
    {
      type: 3,
      nameText: t('R9019'),
      imgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/3.png'),
      activeImgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/3-active.png')
    },
    {
      type: 4,
      nameText: t('R9020'),
      imgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/4.png'),
      activeImgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/4-active.png')
    },
    {
      type: 5,
      nameText: t('R9021'),
      imgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/5.png'),
      activeImgSrc: assetsRequire('@assets/coros-traininghub-v2/images/training-feeling/5-active.png')
    }
  ];
}

let cachedMap;
export function getFeel(t) {
  if (!cachedMap) {
    cachedMap = getFeelTypeOptionsMap();
  }
  return cachedMap[t];
}

export const parseFeelTypeIcon = (t) => {
  const f = getFeel(t);
  return f ? f.activeImgSrc : DEFAULT_FEELTYPE_IMG;
};

export function getFeelTypeOptionsMap() {
  const list = getFeelTypeOptions();
  return list.reduce((acc, item) => {
    acc[item.type] = item;
    return acc;
  }, {});
}
